import { atom } from 'recoil';
import { DEFAULT_LOCALE } from '@enmon-monorepo/i18n';
import type { Locale } from '@enmon/commons';

export const localeAtom = atom<Locale>({
  key: 'app/LanguageProvider/localeState',
  default: DEFAULT_LOCALE,
});
